import React, { useState, useEffect, useRef } from "react";
import $ from "jquery"; // Import jQuery
import "jquery-ui-dist/jquery-ui.css"; // Import jQuery UI CSS
import "jquery-ui-dist/jquery-ui.js"; // Import jQuery UI JS
import { baseurl } from "../../../component/Baseurl";
import axios from "axios";
import { useNavigate } from "react-router-dom";

function MobileForm() {
  const navigate = useNavigate(); // Initialize navigation
  const fromDateRef = useRef(null);
  const toDateRef = useRef(null);

  const [packageSearchTerm, setPackageSearchTerm] = useState("");
  const [isPackageOpen, setIsPackageOpen] = useState(false);
  const [selectedPackage, setSelectedPackage] = useState("Package");
  const [packages, setPackages] = useState([]);

  // Fetch packages from API
  useEffect(() => {
    const fetchPackages = async () => {
      try {
        const response = await axios.get(`${baseurl}GetAllPackagesNew`);
        if (response.data.packages) {
          setPackages(response.data.packages);
        }
      } catch (error) {
        console.error("Error fetching packages:", error);
      }
    };

    fetchPackages();
  }, []);

  const filteredPackages = packages.filter((pkg) =>
    pkg.package_name.toLowerCase().includes(packageSearchTerm.toLowerCase())
  );

  const togglePackageDropdown = () => setIsPackageOpen(!isPackageOpen);
  const handlePackageSearch = (e) => setPackageSearchTerm(e.target.value);
  const selectPackage = (pkg) => {
    setSelectedPackage(pkg.package_name);
    setPackageSearchTerm(pkg.package_name);
    setIsPackageOpen(false);
  };

  // Initialize the datepicker
  useEffect(() => {
    if (fromDateRef.current && toDateRef.current) {
      $(fromDateRef.current).datepicker({
        dateFormat: "yy-mm-dd",
        minDate: 0,
        onSelect: function (selectedDate) {
          $(toDateRef.current).datepicker("option", "minDate", selectedDate);
        },
      });

      $(toDateRef.current).datepicker({
        dateFormat: "yy-mm-dd",
        minDate: 0,
      });
    }
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault(); // Prevent default form submission

    const queryParams = new URLSearchParams({
      package: selectedPackage,
      checkin: fromDateRef.current.value,
      checkout: toDateRef.current.value,
    }).toString();

    navigate(`/all-package?${queryParams}`);
  };

  return (
    <div className="bg-white p-1 rounded">
      <form className="text-start row g-2" onSubmit={handleSubmit}>
        {/* From Date */}
        <div className="col-12">
          <input
            type="text"
            ref={fromDateRef}
            className="input-field mb-0 datepicker"
            placeholder="Select From Date"
          />
        </div>

        {/* To Date */}
        <div className="col-12">
          <input
            type="text"
            ref={toDateRef}
            className="input-field mb-0 datepicker"
            placeholder="Select To Date"
          />
        </div>

        {/* Package Search */}
        <div className="col-12">
          <input
            type="text"
            className="form-control"
            placeholder="Search package"
            value={packageSearchTerm}
            onChange={handlePackageSearch}
            onClick={togglePackageDropdown}
          />
          {isPackageOpen && (
            <div className="dropdown-list">
              <ul>
                {filteredPackages.map((pkg, index) => (
                  <li
                    key={index}
                    className="w-100 mylist1"
                    onClick={() => selectPackage(pkg)}
                  >
                    {pkg.package_name}
                  </li>
                ))}
              </ul>
            </div>
          )}
        </div>

        {/* Search Button */}
        <div className="mb-2 text-center">
          <button className="book-btn" type="submit">
            Search
          </button>
        </div>
      </form>
    </div>
  );
}

export default MobileForm;
